module.exports = "https://cdn.realtymogul.com/static/media/carousel-arrow-small-left.6f07ed7c.svg";